"use client";

import React from "react";
import { Church } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
export default function StatBanner() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="churchplantingstatbanner" data-nav="dark" className="w-full bg-primary text-primary-foreground py-8 md:py-10 shadow-md relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="flex flex-col items-center justify-center text-center space-y-3">
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-primary-foreground">
            <div className="flex items-center justify-center rounded-lg bg-primary-foreground/10 p-2.5 sm:p-3 border border-primary-foreground/20">
              
            </div>
            <h2 className="text-2xl tracking-tight uppercase font-default !font-medium sm:text-4xl md:text-5xl lg:text-6xl">
              {"390,375 IGLESIAS HAN SIDO PLANTADAS"}
            </h2>
          </div>

          <p className="text-sm sm:text-base md:text-lg font-medium text-primary-foreground/85 max-w-2xl">Hacia la meta global de multiplicación al 2033</p>
        </motion.div>
      </div>
    </section>;
}